/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-lines */
"use client";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import dynamic from "next/dynamic";
import CustomImage from "../../../atoms/customImage/index";
import {
  AUTO_TRIGGER_LOCK,
  FROM_LOCATION_LOCK,
  LOCATION_LOCK_HEADING,
  LOCATION_LOCK_ICON_TEXT,
  LOCATION_LOCK_SUB_HEADING,
  LOCATION_MANDATORY,
  LOCATION_MISSING,
} from "../../../../constants/common/locationFieldConstants";
import {
  debounce,
  generateTruncatedString,
  getHash,
  getIconUrl,
  buildIconTintFilter,
  pageName,
  stringWithCommaSplitter,
} from "../../../../utils/common";
import PopOver from "../../../atoms/popOver";
import Typography from "../../../atoms/typography";
import CookieUtil from "../../../../utils/storage/cookieUtil";
import {
  LAST_VISITED_ADDRESS,
  LAST_VISITED_PINCODE,
  LAST_VISITED_PLACE_TYPES,
  SELECTED_SAVED_ADDRESS,
  SELECTED_SAVED_ADDRESS_USERNAME,
  SELECTED_INTERNATIONAL_CITY,
  PF_COOKIE,
} from "../../../../constants/storage";
import {
  setIsHideSavedAddresses,
  setIsSavedAddressUserName,
  setIsShowDesktopLocationLockAction,
  setIsShowMobileLocationLockAction,
  setSelectedIntLocation,
  setSelectedCountryAction,
  setSelectedDomesticLocation,
  getCountryListsData,
  getLocationLockConfigDataAction,
  setIsShowMobileLocationLockDrawerAction,
  onFocusRequestFromTextfield,
  setMandateErrorAction,
  setLocationLockConfigDataAction,
} from "../../../../store/slices/locationLock";
import { useParams, usePathname } from "next/navigation";
import { requestToFetchProductListingAction } from "../../../../store/slices/plpSlice";
import { plpPageConstants } from "../../../../constants/pageConstants/plpConstants";
import { COUNTRIES, DELIVER_TO } from "../../../../constants/common/common";
import { requestToSavedAddress } from "../../../../store/slices/savedAddresses";
import { removeEmptyNullAndUndefinedFromObject } from "../../../../utils/common";
import SavedAddress from "../../../molecules/locationLock/saveAddresses";
import isEmpty from "lodash.isempty";
import useAnalytics from "../../../../analytics/useAnalytics";
import { cleverTapCommonEvents } from "../../../../analytics/clevertapConstants";
import { getCleverTapPageType } from "../../../../utils/fnpPageType";
import { isHomePathname } from "../../../../utils/dynamicHomeUtils/storeUrl";
import { dispatchHomeFeedRefresh } from "../../../../utils/dynamicHomeUtils/refreshHomeFeedAfterLocationChange";
import { lockBody, unlockBody } from "../../../../utils/document";
import MobileLocationLockDrawer from "../../../molecules/locationLock/mobileLocationLockDrawer";
import { GA4_EVENTS } from "../../../../analytics/gaConstant";
import Loader from "../../../atoms/loader";
import {
  fetchCountryFlag,
  getGateAutoTriggerFlag,
  getGateConfig,
  capitalizeWords,
  buildLocationPopupViewedData,
  getEntryAccuracy,
  getLocationSelectionKey,
} from "../../../../utils/locationLock";
import { showCleverTapNotification } from "../../../../analytics/useCleverTap";
import { getLocalStorageItem } from "../../../../utils/storage/localStorageUtil";
import { execDataLayer } from "../../../../utils/cache-layer/cacheLayer";
import { getInternationalDeliveryForRakhi } from "../../../../api/locationLock";
import { useABTestingView } from "../../../../customHooks/clevertap/useABTestingView";
import Portal from "../../../molecules/Portal";

const MobileLocationLock = dynamic(() => import("../../../molecules/locationLock/mobileLocationLock"), { ssr: false });
const LocationLock = dynamic(() => import("../../../molecules/locationLock"), {
  ssr: false,
  loading: () => (
    <div className="relative h-[188px] w-full">
      <Loader position="absolute" />
    </div>
  ),
});

/**
 * Location lock represents the location section in the header.
 * @returns {JSX.Element} The JSX representation of the Header component.
 */
const LocationLockHeader = ({ isMobile, textIconColor }) => {
  const triggerRef = useRef();
  const dispatch = useDispatch();
  const pathname = usePathname();
  const { trackEvent } = useAnalytics();
  const mandateDesktopRef = useRef();
  const [checkIfMandatory, setCheckIfMandatory] = useState(false);
  const [intialLoad, setIntialLoad] = useState(false);
  const { gateConfig: gateConfigValueAB } = useABTestingView();
  const [loadingGate, setLoadingGate] = useState(false);
  const params = useParams();
  const completePathName = typeof window !== "undefined" && window.location.href ? window.location.href : null;

  const {
    isShowMobileLocationLock,
    isShowDesktopLocationLock,
    isShowMobileLocationLockDrawer,
    selectedDomesticLocation,
    appliedFilters,
    appliedSort,
    checkLoginInfo,
    isHideSavedAddresses,
    savedAddresses,
    saveAddressUserName,
    catalogId,
    selectedIntLocation,
    visitedCountry,
    countryListData,
    configData,
    product,
    selectedCountryFromList,
  } = useSelector(
    (state) => ({
      isShowMobileLocationLock: state?.locationLock?.isShowMobileLocationLock,
      isShowDesktopLocationLock: state?.locationLock?.isShowDesktopLocationLock,
      isShowMobileLocationLockDrawer: state?.locationLock?.isShowMobileLocationLockDrawer,
      selectedDomesticLocation: state?.locationLock.selectedDomesticLocation,
      appliedFilters: state?.plp?.appliedFilters,
      appliedSort: state?.plp?.appliedSort,
      checkLoginInfo: state?.fus?.loginDetail,
      isHideSavedAddresses: state?.locationLock?.isHideSavedAddresses,
      savedAddresses: state?.savedAddress?.savedAddresses || [],
      saveAddressUserName: state?.locationLock.savedAddressUserName,
      catalogId: state.appConfig.catalogId,
      selectedIntLocation: state?.locationLock.selectedIntLocation,
      visitedCountry: state?.locationLock.visitedCountry,
      countryListData: state?.locationLock?.countryListData,
      configData: state?.locationLock?.configData,
      product: state?.pdp?.clientCurrentClickedItem,
      selectedCountryFromList: state?.locationLock?.selectedCountryFromList,
    }),
    shallowEqual,
  );
  const {
    isAutoGateEnabledOnDesktopHome,
    isAutoGateMandateOnDesktopHome,
    isAutoGateMandateOnDesktopPLP,
    isAutoGateEnabledOnDesktopPLP,
    isAutoGateEnabledOnMobileHome,
    isAutoGateEnabledOnMobilePLP,
    isAutoGateMandateOnMobileHome,
    isAutoGateMandateOnMobilePLP,
    mandateGatePLPList,
    title,
    description,
  } = configData;
  const postalAddress = CookieUtil.getCookie(SELECTED_SAVED_ADDRESS);
  const selectedUserName = CookieUtil.getCookie(SELECTED_SAVED_ADDRESS_USERNAME);
  const lockLocality = stringWithCommaSplitter(selectedDomesticLocation?.address, 1);
  const lastVisitedAddress = CookieUtil.getCookie(LAST_VISITED_ADDRESS);
  const lastVisitedPincode = CookieUtil.getCookie(LAST_VISITED_PINCODE);
  const selectedIntlCity = CookieUtil.getCookie(SELECTED_INTERNATIONAL_CITY);
  const isHome = isHomePathname(pathname);
  const isPLP = pathname?.includes("-lp");
  const isAutoTriggerLock = getGateAutoTriggerFlag(mandateGatePLPList);
  const isInternational = catalogId !== COUNTRIES.INDIA;
  const urlIdentifier = product?.urlIdentifier;
  const isMandateForDesktop =
    !isAutoTriggerLock &&
    catalogId === COUNTRIES.INDIA &&
    selectedCountryFromList === COUNTRIES.INDIA &&
    ((isAutoGateMandateOnDesktopHome && isHome) || (isAutoGateMandateOnDesktopPLP && isPLP));
  const isMandateForMobile =
    !isAutoTriggerLock &&
    catalogId === COUNTRIES.INDIA &&
    selectedCountryFromList === COUNTRIES.INDIA &&
    ((isAutoGateMandateOnMobileHome && isHome) || (isAutoGateMandateOnMobilePLP && isPLP));
  const isAutoForDesktop =
    !isAutoTriggerLock && ((isAutoGateEnabledOnDesktopHome && isHome) || (isAutoGateEnabledOnDesktopPLP && isPLP));
  const isAutoForMobile =
    !isAutoTriggerLock && ((isAutoGateEnabledOnMobileHome && isHome) || (isAutoGateEnabledOnMobilePLP && isPLP));

  mandateDesktopRef.current = isMandateForDesktop;

  const pageType = (typeof window !== "undefined" && window.fnpPageType) || "";
  const mandatory = isAutoTriggerLock ? false : isMobile ? isMandateForMobile : isMandateForDesktop;
  const auto = isAutoTriggerLock ? false : isMobile ? isAutoForMobile : isAutoForDesktop;
  const commonPageData = {
    page_name: pageName(isHome, isPLP, pathname, urlIdentifier),
    page_type: getCleverTapPageType(pageType),
    is_location_available: !!(lastVisitedPincode || lastVisitedAddress),
    clean_url: pathname,
    complete_url: completePathName,
  };
  const pageLocationPopupData = buildLocationPopupViewedData({
    page_name: commonPageData.page_name,
    page_type: getCleverTapPageType(pageType),
    is_location_available: !!(lastVisitedPincode || lastVisitedAddress || selectedIntLocation?.pincode),
    mandatory,
    auto,
    user_initiated: isAutoTriggerLock
      ? true
      : isMobile
        ? !(isAutoForMobile || isMandateForMobile)
        : !(isAutoForDesktop || isMandateForDesktop),
    pincode: !isInternational ? lastVisitedPincode || selectedDomesticLocation?.pincode || "" : "",
    area: !isInternational ? lastVisitedAddress || selectedDomesticLocation?.address || "" : "",
    system_pincode: !isInternational ? lastVisitedPincode || selectedDomesticLocation?.pincode || "" : "",
    country: catalogId,
    city: isInternational ? selectedIntLocation?.location : "",
    is_bottom_sheet: Boolean(isMobile && (isShowMobileLocationLock || isShowMobileLocationLockDrawer)),
    is_saved_address_available: Boolean(savedAddresses?.length),
    clean_url: pathname,
    complete_url: completePathName,
    pid: product?.productId || "",
    sku_id: product?.skuCode || "",
    entry_accuracy: getEntryAccuracy(),
  });
  const locationPopupEntryRef = useRef({ accuracy: getEntryAccuracy(), key: "" });

  useEffect(() => {
    if (getHash() === FROM_LOCATION_LOCK) {
      dispatch(setIsShowMobileLocationLockAction(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  useEffect(() => {
    const isMyAccountPage = /\/account(\/|$)/.test(pathname || "");
    if (checkLoginInfo?.loggedin && !isMyAccountPage) {
      dispatch(requestToSavedAddress());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkLoginInfo?.loggedin, pathname]);

  useEffect(() => {
    if (gateConfigValueAB !== undefined && !isEmpty(configData) && isPLP && !intialLoad) {
      const configObj = getGateConfig(gateConfigValueAB, configData);
      dispatch(setLocationLockConfigDataAction(configObj));
      setIntialLoad(true);
    }
  }, [gateConfigValueAB?.length, configData]);

  useEffect(() => {
    let timer;

    if (!isShowDesktopLocationLock && !isMobile) {
      timer = setTimeout(() => {
        showCleverTapNotification();
      }, 2000);
    }

    return () => clearTimeout(timer);
  }, [isShowDesktopLocationLock, isMobile]);

  useEffect(() => {
    if (Array.isArray(countryListData)) {
      const filterData = countryListData?.filter((item) => {
        return item?.catelogID === catalogId;
      })?.[0];

      dispatch(setSelectedCountryAction(filterData));
    }
  }, [countryListData, catalogId]);

  useEffect(() => {
    if (isEmpty(countryListData)) {
      dispatch(getCountryListsData());
    }

    const getIntDeliveryRakhiFromStorage = getLocalStorageItem("getIntDeliveryForRakhi");
    if (!getIntDeliveryRakhiFromStorage) {
      // Fetch and set the flag value in local storage
      (async () => {
        await execDataLayer(getInternationalDeliveryForRakhi, "getIntDeliveryForRakhi");
      })();
    }
  }, []);

  useEffect(() => {
    if (
      ((isEmpty(selectedDomesticLocation) && catalogId === COUNTRIES.INDIA) ||
        (isEmpty(selectedIntLocation?.pincode) && catalogId !== COUNTRIES.INDIA)) &&
      !isAutoTriggerLock
    ) {
      if (!Object.keys(configData)?.length) {
        dispatch(getLocationLockConfigDataAction());
      } else {
        if (
          (isAutoGateEnabledOnDesktopHome && isHome && !isMobile) ||
          (isAutoGateEnabledOnDesktopPLP && isPLP && !isMobile)
        ) {
          dispatch(setIsShowDesktopLocationLockAction(true));
        }
        if (
          (isAutoGateEnabledOnMobileHome && isHome && isMobile) ||
          (isAutoGateEnabledOnMobilePLP && isPLP && isMobile)
        ) {
          dispatch(setIsShowMobileLocationLockDrawerAction(true));
        }
        if ((!isAutoGateEnabledOnDesktopPLP || !isAutoGateEnabledOnMobilePLP) && isPLP) {
          if (isMobile) {
            dispatch(setIsShowMobileLocationLockDrawerAction(false));
          } else {
            dispatch(setIsShowDesktopLocationLockAction(false));
          }
        }
      }
    } else {
      setCheckIfMandatory(false);
    }
  }, [configData, selectedDomesticLocation, selectedIntLocation?.pincode]);

  useEffect(() => {
    // Desktop location popover only — do not track the auto mobile mini-drawer on page land.
    // Full-screen mobile lock is tracked from MobileLocationLock when it mounts/opens.
    if (isShowDesktopLocationLock) {
      const entryKey = isInternational
        ? getLocationSelectionKey(selectedIntLocation?.pincode, selectedIntLocation?.location)
        : getLocationSelectionKey(
            selectedDomesticLocation?.pincode || lastVisitedPincode,
            selectedDomesticLocation?.address || lastVisitedAddress,
          );
      locationPopupEntryRef.current = { accuracy: getEntryAccuracy(), key: entryKey };
      trackEvent(
        cleverTapCommonEvents.locationPopupViewed,
        { ...pageLocationPopupData, entry_accuracy: locationPopupEntryRef.current.accuracy },
        ["clevertap"],
      );
    }
  }, [isShowDesktopLocationLock]);

  useEffect(() => {
    const jsonSelectedIntlCity = JSON.parse(selectedIntlCity);

    if (!isEmpty(jsonSelectedIntlCity) && catalogId !== COUNTRIES.INDIA) {
      const selectedCountriesValues = Object.values(jsonSelectedIntlCity);

      const selectedCountry = selectedCountriesValues.filter((country) => {
        return country.catalogId === catalogId;
      })?.[0];

      dispatch(setSelectedIntLocation({ pincode: selectedCountry?.cityId, location: selectedCountry?.city }));
      dispatch(setSelectedCountryAction(selectedCountry));
    } else {
      if (lastVisitedAddress && lastVisitedPincode) {
        dispatch(setSelectedDomesticLocation({ pincode: lastVisitedPincode, address: lastVisitedAddress }));
        trackEvent(GA4_EVENTS?.PINCODE_AVAILABLE, { pincode: lastVisitedPincode }, ["ga4"]);
        if (selectedUserName) dispatch(setIsSavedAddressUserName(selectedUserName));
      } else if (postalAddress && selectedUserName && savedAddresses.length) {
        const userSelectedAddress = savedAddresses.find((item) => item?.postalAddress === postalAddress);
        const options = {
          maxAge: 60 * 24 * 60 * 30,
          path: "/",
          encode: decodeURIComponent,
        };

        const formattedAddress = [
          userSelectedAddress?.address,
          userSelectedAddress?.address2,
          userSelectedAddress?.city,
          userSelectedAddress?.postalcode,
        ]
          .filter(Boolean)
          .map(capitalizeWords)
          .join(", ");

        dispatch(setIsSavedAddressUserName(selectedUserName));

        CookieUtil.setCookie(LAST_VISITED_PINCODE, userSelectedAddress?.postalcode, options);
        CookieUtil.setCookie(LAST_VISITED_ADDRESS, formattedAddress, options);
        dispatch(
          setSelectedDomesticLocation({
            pincode: userSelectedAddress?.postalcode,
            address: formattedAddress,
          }),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIntlCity, catalogId, lastVisitedAddress, lastVisitedPincode, savedAddresses]);

  /**
   * Determines the delivery address text to display based on the selected location and catalog.
   *
   * @returns {string} - The formatted delivery location text based on the available data.
   */
  const getDeliverToText = () => {
    if (catalogId !== COUNTRIES.INDIA) {
      if (
        !isEmpty(visitedCountry?.countryName) &&
        visitedCountry?.catelogID !== COUNTRIES.INDIA &&
        !isEmpty(selectedIntLocation?.location)
      ) {
        return visitedCountry?.countryName;
      }
      return LOCATION_MISSING;
    }

    if ((selectedDomesticLocation?.pincode || selectedDomesticLocation?.address) && catalogId === COUNTRIES.INDIA) {
      // Area / locality picked from Google: show the place only (the pincode is still stored and used as is).
      if (selectedDomesticLocation?.address && CookieUtil.getCookie(LAST_VISITED_PLACE_TYPES)) {
        return selectedDomesticLocation.address;
      }
      return `${selectedDomesticLocation?.address}, ${selectedDomesticLocation?.pincode}`;
    }

    return LOCATION_MISSING;
  };

  /**
   * Determines the locality text to display based on the selected location and catalog.
   *
   * @returns {string} - The locality text based on the selected location.
   */
  const getlockLocality = () => {
    if (catalogId !== COUNTRIES.INDIA) {
      if (!isEmpty(selectedIntLocation?.location)) {
        return (
          <div className="flex items-end gap-4">
            <Typography
              variant="p"
              Tag="p"
              classes="inter text-12 xxl:text-14 font-500"
              style={{ color: textIconColor || "#444444" }}
            >
              {DELIVER_TO}
            </Typography>
            <Typography
              variant="p"
              Tag="p"
              classes="block max-w-[174px] overflow-hidden text-ellipsis whitespace-nowrap inter text-14 xxl:text-18 capitalize font-600 leading-5"
              style={{ color: textIconColor || "#191A0B" }}
            >
              {selectedIntLocation?.location}
            </Typography>
          </div>
        );
      }

      return LOCATION_LOCK_ICON_TEXT;
    }

    if (saveAddressUserName && catalogId === COUNTRIES.INDIA) {
      return (
        <div className="flex items-end gap-4">
          <Typography
            variant="p"
            Tag="p"
            classes="inter text-12 xxl:text-14 font-500"
            style={{ color: textIconColor || "#444444" }}
          >
            {DELIVER_TO}
          </Typography>
          <Typography
            variant="p"
            Tag="p"
            classes="block max-w-[174px] overflow-hidden text-ellipsis whitespace-nowrap inter text-14 xxl:text-18 capitalize font-600 leading-5"
            style={{ color: textIconColor || "#191A0B" }}
          >
            {generateTruncatedString(saveAddressUserName, 20)}
          </Typography>
        </div>
      );
    }

    if ((selectedDomesticLocation?.pincode || selectedDomesticLocation?.address) && catalogId === COUNTRIES.INDIA) {
      return (
        <div className="flex items-end gap-4">
          <Typography
            variant="p"
            Tag="p"
            classes="inter text-12 xxl:text-14 font-500"
            style={{ color: textIconColor || "#444444" }}
          >
            {DELIVER_TO}
          </Typography>
          <Typography
            variant="p"
            Tag="p"
            classes="block max-w-[170px] overflow-hidden text-ellipsis whitespace-nowrap inter text-14 xxl:text-18 capitalize font-600 leading-5"
            style={{ color: textIconColor || "#191A0B" }}
          >
            {lockLocality}
          </Typography>
        </div>
      );
    }

    return LOCATION_LOCK_ICON_TEXT;
  };

  /**
   * Sets the auto trigger lock cookie if the conditions are met.
   */
  const setAutoTriggerLockHandler = (autoTriggerLockTime) => {
    if ((isHome || isPLP) && autoTriggerLockTime) {
      CookieUtil.setCookie(AUTO_TRIGGER_LOCK, autoTriggerLockTime.toString(), {
        maxAge: autoTriggerLockTime,
        path: "/",
        encode: decodeURIComponent,
        secure: true,
      });
    }
  };

  /**
   * function responsible to handle visibility
   * return bool
   */
  const onHandleVisibility = debounce((isNotFromLocationLockPincodeSelection) => {
    // LocationLock calls with `false` after a successful confirm. Close every surface
    // instead of toggling open — otherwise a race with integratedGoogleSuggestionField's
    // own close leaves the popover/drawer stuck open (notably on /gift-finder).
    if (isNotFromLocationLockPincodeSelection === false) {
      dispatch(setIsShowMobileLocationLockAction(false));
      dispatch(setIsShowMobileLocationLockDrawerAction(false));
      dispatch(setIsShowDesktopLocationLockAction(false));
      unlockBody();
      setLoadingGate(false);
      return;
    }

    setLoadingGate(true);
    if (isMobile) {
      dispatch(setIsShowMobileLocationLockAction(true));
      setLoadingGate(false);
      dispatch(setIsHideSavedAddresses(false));
      if (isInternational ? isEmpty(selectedIntLocation) : isEmpty(selectedDomesticLocation)) {
        dispatch(onFocusRequestFromTextfield(true));
      } else {
        dispatch(onFocusRequestFromTextfield(false));
      }
      trackEvent(
        cleverTapCommonEvents.locationClicked,
        {
          ...commonPageData,
          mandatory: false,
          auto: false,
          user_initiated: true,
          flow: "new",
        },
        ["clevertap"],
      );
    } else {
      if (isShowDesktopLocationLock) {
        setLoadingGate(false);
        if (isNotFromLocationLockPincodeSelection) {
          const inputEmpty = !document.getElementById("pincode-location-input")?.value?.trim();
          if (!selectedDomesticLocation?.pincode || (isHome && inputEmpty)) {
            CookieUtil.deleteCookie(PF_COOKIE);
            CookieUtil.deleteCookie(LAST_VISITED_ADDRESS);
            CookieUtil.deleteCookie(LAST_VISITED_PINCODE);
            // Updating listing on PLP page on pincode change
            if (pathname?.includes("-lp")) {
              window.scrollTo({ top: 0 });
              // Get email from faul cookie
              const email = CookieUtil.getCookie("faul") || "";
              dispatch(
                requestToFetchProductListingAction(
                  removeEmptyNullAndUndefinedFromObject({
                    page: 0, //details?.currentPage,
                    size: isMobile
                      ? plpPageConstants.MOBILE_PRODUCT_PER_PAGE
                      : plpPageConstants.DESKTOP_PRODUCT_PER_PAGE,
                    geoId: COUNTRIES?.INDIA,
                    categoryUrl: `fnp.com${pathname}`,
                    filters: appliedFilters,
                    sortBy: appliedSort?.sortBy,
                    sortOrder: appliedSort?.sortOrder,
                    email,
                  }),
                ),
              );
            }
            if (isHome && catalogId === COUNTRIES.INDIA && inputEmpty) {
              dispatchHomeFeedRefresh(dispatch, { isMobile: false });
            }
          }
        }
        dispatch(setIsShowDesktopLocationLockAction(false));
      } else {
        const clevertapCommonPopupData = { mandatory: false, auto: false, user_initiated: true, flow: "new" };
        trackEvent(
          cleverTapCommonEvents.locationClicked,
          {
            ...commonPageData,
            ...clevertapCommonPopupData,
          },
          ["clevertap"],
        );
        dispatch(setIsShowDesktopLocationLockAction(true));
        dispatch(setIsHideSavedAddresses(false));
        setLoadingGate(false);
      }
    }
  }, 100);
  /**
   * Toogle Popover Handler.
   * @returns
   */
  const onTogglePopOverHandler = () => {
    mandateDesktopRef?.current && isEmpty(selectedDomesticLocation)
      ? (setCheckIfMandatory(true), dispatch(setMandateErrorAction(true)))
      : onHandleVisibility(true);
    if (!(mandateDesktopRef?.current && isEmpty(selectedDomesticLocation))) {
      const inputEmpty = !document.getElementById("pincode-location-input")?.value?.trim();
      const willClearLocation =
        isShowDesktopLocationLock && (!selectedDomesticLocation?.pincode || (isHome && inputEmpty));
      const currentKey = willClearLocation
        ? ""
        : isInternational
          ? getLocationSelectionKey(selectedIntLocation?.pincode, selectedIntLocation?.location)
          : getLocationSelectionKey(selectedDomesticLocation?.pincode, selectedDomesticLocation?.address);
      const entry = isShowDesktopLocationLock
        ? locationPopupEntryRef.current
        : {
            accuracy: getEntryAccuracy(),
            key: isInternational
              ? getLocationSelectionKey(selectedIntLocation?.pincode, selectedIntLocation?.location)
              : getLocationSelectionKey(selectedDomesticLocation?.pincode, selectedDomesticLocation?.address),
          };
      trackEvent(
        cleverTapCommonEvents.locationPopupClosed,
        {
          ...pageLocationPopupData,
          pincode: null,
          area: null,
          system_pincode: null,
          country: null,
          city: null,
          entry_accuracy: entry?.accuracy || "",
          is_location_retained: Boolean(entry?.key) && entry.key === currentKey,
        },
        ["clevertap"],
      );
    }
    if (!isMandateForDesktop) {
      showCleverTapNotification();
      setAutoTriggerLockHandler(configData?.autoTriggerLock);
    }
  };

  /**
   * To Continue Shopping by selecting location.
   */
  const onContinueShoppingClick = () => {
    if (!isMandateForMobile) {
      unlockBody();
      dispatch(setIsShowMobileLocationLockDrawerAction(false));
      setAutoTriggerLockHandler(configData?.autoTriggerLock);
    } else if (isEmpty(selectedDomesticLocation)) {
      lockBody();
      setCheckIfMandatory(isMandateForMobile);
      dispatch(setMandateErrorAction(true));
    }
  };

  return (
    <div className="flex gap-5" tabIndex="0" ref={triggerRef}>
      {loadingGate && <Loader position="fixed" />}
      <span className="relative flex min-w-[150px]  max-w-[200px] items-center justify-start gap-8 md:max-w-[250px]">
        <div className="relative grid w-[150px] cursor-pointer md:w-[250px]" onClick={() => onHandleVisibility(true)}>
          <div className="flex w-full gap-8">
            <CustomImage
              src={fetchCountryFlag(countryListData, catalogId)}
              alt="location-icon"
              width={24}
              height={24}
              className="my-auto"
            />
            <div>
              <div className="flex items-center gap-2">
                <span
                  className={`block max-w-[174px] overflow-hidden text-ellipsis whitespace-nowrap text-16 font-600 md:text-16 xxl:text-18`}
                  style={{ color: textIconColor || "#444444" }}
                >
                  {getlockLocality()}
                </span>
                {getlockLocality() != LOCATION_LOCK_ICON_TEXT && (
                  <img
                    src={getIconUrl("/icons/filter-chevron.svg")}
                    alt="filter-chevron"
                    aria-hidden="true"
                    width={14}
                    height={14}
                    className="h-14 w-14 flex-shrink-0 object-contain"
                    style={{
                      width: 14,
                      height: 14,
                      filter: buildIconTintFilter(textIconColor || "#444444"),
                    }}
                  />
                )}
              </div>
              <div className="flex items-center gap-2">
                <span
                  className="flex items-center justify-start gap-4 text-12 font-500 xxl:text-14"
                  style={{ color: getDeliverToText() != LOCATION_MISSING ? textIconColor || "#444444" : "#ef4444" }}
                >
                  <span className="w-full max-w-[150px] overflow-hidden text-ellipsis whitespace-nowrap md:max-w-[200px]">
                    {getDeliverToText()}
                  </span>
                  {getDeliverToText() === LOCATION_MISSING && (
                    <CustomImage
                      className="w-auto max-w-full"
                      src={"/icons/chevron-location.svg"}
                      alt="down_red_arrow"
                      width={16}
                      height={16}
                    />
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
        {isMobile && isShowMobileLocationLockDrawer && (
          <MobileLocationLockDrawer
            isShowMobileLocationLockDrawer={isShowMobileLocationLockDrawer}
            onContinueShoppingClick={onContinueShoppingClick}
            isMandateForMobile={isMandateForMobile}
            isAutoForMobile={isAutoForMobile}
            checkIfMandatory={checkIfMandatory}
          />
        )}
        {isMobile ? (
          isShowMobileLocationLock && (
            <Portal rootId="fnpRootId" renderOnDidMount={true}>
              <MobileLocationLock isMandatoryLocation={checkIfMandatory} isAutoLocation={isAutoForMobile} />
            </Portal>
          )
        ) : (
          <PopOver
            isVisible={isShowDesktopLocationLock}
            isBackdrop={true}
            onTogglePopover={onTogglePopOverHandler}
            triggerRef={triggerRef}
            topOffset={65}
            classes="p-20"
            isShowCancelIcon={!(isMandateForDesktop && isEmpty(selectedDomesticLocation))}
            commonPageData={commonPageData}
          >
            <div
              className="relative flex h-full w-full flex-col flex-wrap bg-white-900 md:h-max md:w-[440px] md:rounded-2xl"
              id="locationLock"
              data-testid="locationLock"
            >
              <div className="absolute right-2 top-2 hidden md:block" />
              <div className="flex w-full">
                <div className="pr-8">
                  <CustomImage
                    src="/icons/location-Icon.svg"
                    alt="Location"
                    sizes="10vw"
                    width={24}
                    height={24}
                    isPriority={false}
                  />
                </div>
                <Typography variant="p" Tag="p" classes="font-600 text-16 text-fnp-500">
                  {title || LOCATION_LOCK_HEADING}
                </Typography>
              </div>
              <div className="w-full py-8">
                <Typography variant="p" Tag="p" classes="text-12 font-400 text-grey-500">
                  {description || LOCATION_LOCK_SUB_HEADING}
                </Typography>
              </div>
              {savedAddresses.length > 0 && !isHideSavedAddresses && catalogId === COUNTRIES.INDIA && (
                <SavedAddress postalAddress={postalAddress} savedAddress={savedAddresses} />
              )}
              <LocationLock
                onShowHideLocationLock={onHandleVisibility}
                isLocationError={checkIfMandatory}
                messageText={LOCATION_MANDATORY}
                setMandatoryError={(isDisable) => setCheckIfMandatory(isDisable)}
              />
            </div>
          </PopOver>
        )}
      </span>
    </div>
  );
};

LocationLockHeader.propTypes = { isMobile: PropTypes.bool, textIconColor: PropTypes.string };

export default LocationLockHeader;
